import React from 'react';
import styled from 'styled-components';
import HealthInsurance from "../../../../resources/images/careers/health-insurance.svg";
import DentalInsurance from "../../../../resources/images/careers/dental-insurance.svg";
import Hsa from "../../../../resources/images/careers/hsa.svg";
import VisionInsurance from "../../../../resources/images/careers/vision-insurance.svg";
import Retirement from "../../../../resources/images/careers/401k.svg";
import CompanySwag from "../../../../resources/images/careers/company-swag.svg";
import UnlimitedPto from "../../../../resources/images/careers/unlimited-pto.svg";
import TeamRecognition from "../../../../resources/images/careers/team-recognition.svg";
import TeamActivities from "../../../../resources/images/careers/team-activities.svg";
import colors from '../../../../helpers/colors';

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 170px auto;

    @media (max-width: 1250px) {
        padding: 0 20px;
    }

    @media (max-width: 850px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    @media (max-width: 500px) {
        flex-direction: column;
        padding: 0px 28px 0 28px;
        margin: 80px auto;
    }
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 510px;

    @media (max-width: 1000px) {
        max-width: 400px;
    }

    @media (max-width: 850px) {
        max-width: none;
        width: 100%;
        text-align: center;
        margin-bottom: 50px;
    }

`;

const Title = styled.h3`
    font-size: 30px;
    font-weight: 900;
    color: ${colors.mvDarkGrey};
    line-height: 1.5;

    @media (max-width: 500px) {
        width: 100%;
        font-size: 25px;
    }

`;

const Description = styled.p`
    font-size: 16px;
    color: ${colors.paragraphTextColor};
    line-height: 1.5;
    margin: 0 auto;
    margin-top: 20px;
`;

const FlexContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    max-width: 700px;
    margin-left: 75px;

    @media (max-width: 1250px) {
        margin-left: 40px;
    }

    @media (max-width: 1050px) {
        width: 100%;
    }

    @media (max-width: 769px) {
        margin-left: 0;
        justify-content: center;
    }
    @media (max-width: 380px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`;

const TileContainer = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    position: relative;
    margin: 20px 8px;
    width: 187px;
    height: 100px;
    border-radius: 8px;
    box-shadow: 0px 12px 22px ${colors.greyBoxShadow};
    padding: 10px;

    @media (max-width: 1250px) {
        width: 30%;
    }

    @media (max-width: 1100px) {
        width: 29%;
        margin: 20px 5px;
    }

    @media (max-width: 1100px) {
        width: 29%;
        margin: 20px 5px;
        height: 110px;
    }

    @media (max-width: 500px) {
        width: 45%;
        margin: 30px 8px;
    }
    @media (max-width: 380px) {
        width: 90%;
        height: 90px;
        margin: 25px 8px;
    }

`;

const TileTitle = styled.h3`
    font-size: 17px;
    font-weight: 900;
    color: ${colors.mvDarkGrey};
    margin: 35px auto 0 auto; 
    
    @media (max-width: 1250px) {
        margin-top: 30px;
    }
`;

const ImageContainer = styled.div`
    position: absolute;
    right: 0;
    left: 0;
    top: -25px;
`;

const PillarsSection = () => {

    return (
        <Wrapper>
            <ContentContainer>
                <Title>Motivosity's Perks and Benefits</Title>
                <Description>
                    We practice what we preach. We don't need an office full of free snacks and drinks (although we have some available), 
                    ping-pong tables, or arcade machines. We believe happiness at work is achieved through gratitude and connectedness. 
                    And it helps that we have a great work-life balance!
                </Description>
                <Description> 
                    We are all about happiness at work and want to make a tangible difference in the world. We truly are the modern employee recognition 
                    software for a modern workforce.
                </Description>
            </ContentContainer>
            


            <FlexContainer>
                <TileContainer>
                    <ImageContainer>
                        <img src={HealthInsurance} alt="Heart icon" width="50" />
                    </ImageContainer>
                    <TileTitle>Health Insurance</TileTitle>
                </TileContainer> 

                <TileContainer>
                    <ImageContainer>
                        <img src={DentalInsurance} alt="Tooth icon" width="50" />
                    </ImageContainer>
                    <TileTitle>Dental Insurance</TileTitle>
                </TileContainer> 

                <TileContainer>
                    <ImageContainer>
                        <img src={Hsa} alt="Dollar icon" width="50" />
                    </ImageContainer>
                    <TileTitle>Health Saving Account</TileTitle>
                </TileContainer> 

                <TileContainer>
                    <ImageContainer>
                        <img src={VisionInsurance} alt="Glasses icon" width="50" />
                    </ImageContainer>
                    <TileTitle>Vision Insurance</TileTitle>
                </TileContainer> 

                <TileContainer>
                    <ImageContainer>
                        <img src={Retirement} alt="Safe icon" width="50" />
                    </ImageContainer>
                    <TileTitle>401K</TileTitle>
                </TileContainer> 

                <TileContainer>
                    <ImageContainer>
                        <img src={CompanySwag} alt="Shirt icon" width="50" />
                    </ImageContainer>
                    <TileTitle>Company Swag</TileTitle>
                </TileContainer> 

                <TileContainer>
                    <ImageContainer>
                        <img src={UnlimitedPto} alt="Sun icon" width="50" />
                    </ImageContainer>
                    <TileTitle>Unlimited PTO</TileTitle>
                </TileContainer> 

                <TileContainer>
                    <ImageContainer>
                        <img src={TeamRecognition} alt="Gift icon" width="50" />
                    </ImageContainer>
                    <TileTitle>Team Recognition</TileTitle>
                </TileContainer>

                <TileContainer>
                    <ImageContainer>
                        <img src={TeamActivities} alt="Bowling icon" width="50" />
                    </ImageContainer>
                    <TileTitle>Team Activities</TileTitle>
                </TileContainer> 
            </FlexContainer>
        </Wrapper>
    );
};

export default PillarsSection;
